// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default
  class TestSpriteAnimated {
  private _sheetAnimated?: vf.gui.SpriteAnimated;
  private _buttonList: vf.gui.Label[] = [];

  private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

    /** 序列帧动画，设置spritesheet方式填充，或[texture1,textures2]方式 */
    const sheetAnimated = this._sheetAnimated = new vf.gui.SpriteAnimated();
    sheetAnimated.style.left = 700;
    sheetAnimated.style.top = 500;

    sheetAnimated.animationSpeed = 0.1;
    //sheetAnimated.animationName = "1";
    sheetAnimated.loop = true;
    sheetAnimated.loopCount = 0;//设置循环次数，0为不限制
    sheetAnimated.src = vf.Loader.shared.resources["ccc"].spritesheet; //方式1，有可使用位图数组填充
    sheetAnimated.anchorX = 0.5;
    sheetAnimated.anchorY = 1;

    // let spritesheet = vf.Loader.shared.resources["role"].spritesheet;
    // sheetAnimated.animationName = "default";
    // sheetAnimated.src =[spritesheet.textures["1_role2-sheet1.png"],spritesheet.textures["1_role2-sheet2.png"]];

    sheetAnimated.play();

    uiStage.addChild(sheetAnimated);

    sheetAnimated.isClick = true;
    sheetAnimated.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
      if (sheetAnimated.animationName == "0") {
        sheetAnimated.animationName = "1";
      } else {
        sheetAnimated.animationName = "0";
      }
    });

    sheetAnimated.on(vf.gui.Interaction.ComponentEvent.CHANGE, (sa: vf.gui.SpriteAnimated) => {
      console.log("CHANGE");
    });

    sheetAnimated.on(vf.gui.Interaction.ComponentEvent.LOOP, (sa: vf.gui.SpriteAnimated) => {
      console.log("LOOP");
    });

    sheetAnimated.on(vf.gui.Interaction.ComponentEvent.COMPLETE, (sa: vf.gui.SpriteAnimated) => {
      console.log("COMPLETE");
    })


    this.getButton('设置/取消animationSpeed', () => {
      if (sheetAnimated.animationSpeed !== 1) {
        sheetAnimated.animationSpeed = 1;
      } else {
        sheetAnimated.animationSpeed = 0.1;
      }
    }, uiStage, 15, 0);


    this.getButton('设置/取消animationName', () => {
      if (sheetAnimated.animationName !== "666") {
        sheetAnimated.animationName = "666";
        console.log(sheetAnimated.animationName);
      } else {
        sheetAnimated.animationName = "1";
        console.log(sheetAnimated.animationName);
      }
    }, uiStage, 15, 0);




    this.getButton('设置/取消loop', () => {
      if (sheetAnimated.loop !== false) {
        sheetAnimated.loop = false;

      } else {
        sheetAnimated.loop = true;

      }
    }, uiStage, 15, 0);






    this.getButton('设置/取消loopCount', () => {
      if (sheetAnimated.loopCount !== 66) {
        sheetAnimated.loopCount = 66;

      } else {
        sheetAnimated.loopCount = 30;

      }
    }, uiStage, 15, 0);



    this.getButton('设置/取消anchorX', () => {
      if (sheetAnimated.anchorX !== 1) {
        sheetAnimated.anchorX = 1;

      } else {
        sheetAnimated.anchorX = 0.5;

      }
    }, uiStage, 15, 0);


    this.getButton('设置/取消src', () => {
      if (sheetAnimated.src != undefined) {
        sheetAnimated.src = undefined;

      } else {
        sheetAnimated.animationName = 'mic';
        sheetAnimated.src = vf.Loader.shared.resources["mic"].spritesheet;

      }
    }, uiStage, 15, 0);





    this.getButton('设置/取消anchorY', () => {
      if (sheetAnimated.anchorY !== 2) {
        sheetAnimated.anchorY = 2;

      } else {
        sheetAnimated.anchorY = 1;

      }
    }, uiStage, 15, 0);



    this.getButton('设置/取消autoPlay', () => {
      if (sheetAnimated.autoPlay !== true) {
        sheetAnimated.autoPlay = true;

      } else {
        sheetAnimated.autoPlay = false;

      }
    }, uiStage, 15, 0);


    this.getButton('设置/取消isPlay', () => {
      if (sheetAnimated.isPlay !== true) {
        sheetAnimated.isPlay = true;

      } else {
        sheetAnimated.isPlay = false;

      }
    }, uiStage, 15, 0);



    // this.getButton('设置/取消src', () => {
    //   if (sheetAnimated.src!== null) {
    //     let spritesheet = vf.Loader.shared.resources["role"].spritesheet;
    //     sheetAnimated.src =[spritesheet.textures["1_role2-sheet1.png"],spritesheet.textures["1_role2-sheet2.png"]];

    //   } else {
    //     sheetAnimated.animationName="1";

    //   }
    // }, uiStage, 15, 0);















  }

  public constructor(app: vf.Application, uiStage: vf.gui.Stage) {

    const loader = vf.Loader.shared;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loader.add("role", 'assets/1_role2/1_role2.json');
    loader.add("ccc", 'assets/ccc.json');
    loader.add("mic", 'assets/mic.json');
    loader.load(()=>{
      this.onLoad(app, uiStage);
    });
  }







  private posY = 10;
  private getButton(title: string, fun: Function, target: any, x: number, y: number) {
    const button = new vf.gui.Label;
    button.style.fontSize = 24;
    button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
    button.style.fontWeight = 500;
    button.style.color = 0xffffff;
    button.style.lineHeight = 45;
    button.text = title;
    button.interactabled = true;
    button.x = x;
    button.y = this.posY;
    button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
    target.addChild(button);
    this.posY = this.posY + 25 + y;
    this._buttonList.push(button);
  }

  private onRelease() {
    if (this._sheetAnimated) {
      this._sheetAnimated.removeAllListeners();
      this._sheetAnimated.parent && this._sheetAnimated.parent.removeChild(this._sheetAnimated);
      this._sheetAnimated.release();
      this._sheetAnimated = undefined;
    }
    if (this._buttonList && this._buttonList.length > 0) {
      this._buttonList.forEach(element => {
        element.removeAllListeners();
        element.parent && element.parent.removeChild(element);
        element.release();
      });
      this._buttonList = [];
    }
  }

}

